export const messages = {
  en: {
    communityIntegral: {
      title: 'Community Points',
      accountId: 'Account ID:',
      accountName: 'Account Name:',
      points: 'Points:',
      withdraw: 'Withdraw',
      transactionDetails: 'Transaction Details',
      pointsWithdrawal: 'Points Withdrawal'
    },
    communityIntegralDetail: {
      id: 'ID',
      integralAccount: 'Points Account',
      type: 'Type',
      transferIn: 'Transfer In',
      transferOut: 'Transfer Out',
      transactionAmount: 'Amount',
      currentAmount: 'Balance',
      transactionNo: 'Transaction No',
      remark: 'Remark',
      time: 'Time'
    },
    applyWithholdIntegral: {
      id: 'ID',
      integralId: 'Points ID',
      integralName: 'Points Name',
      withdrawAmount: 'Amount',
      applicant: 'Applicant',
      applicantPhone: 'Phone',
      bankAccount: 'Bank Account',
      accountName: 'Account Name',
      bank: 'Bank',
      applicationNote: 'Note',
      status: 'Status',
      reviewNote: 'Review Note'
    },
    deleteApplyWithholdIntegral: {
      confirmTitle: 'Confirm Operation',
      confirmText: 'Are you sure to delete this withdrawal application?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    },
    withholdIntegral: {
      applyWithdraw: 'Apply Withdrawal',
      totalPoints: 'Total Points',
      withdrawPoints: 'Withdraw Points',
      withdrawPointsPlaceholder: 'Required, please enter withdraw points',
      withdrawPointsRequired: 'Withdraw points is required',
      applicant: 'Applicant',
      applicantPlaceholder: 'Required, please enter applicant name',
      applicantRequired: 'Applicant is required',
      applicantPhone: 'Phone',
      applicantPhonePlaceholder: 'Required, please enter phone number',
      applicantPhoneRequired: 'Phone is required',
      bankAccount: 'Bank Account',
      bankAccountPlaceholder: 'Required, please enter bank account',
      bankAccountRequired: 'Bank account is required',
      accountName: 'Account Name',
      accountNamePlaceholder: 'Required, please enter account name',
      accountNameRequired: 'Account name is required',
      bank: 'Bank',
      bankPlaceholder: 'Required, please enter bank name',
      bankRequired: 'Bank is required',
      applicationNote: 'Note',
      applicationNotePlaceholder: 'Required, please enter application note',
      applySuccess: 'Apply successfully',
      applyFailed: 'Apply failed'
    }
  },
  zh: {
    communityIntegral: {
      title: '园区积分',
      accountId: '账户ID：',
      accountName: '账户名称：',
      points: '积分数：',
      withdraw: '提现',
      transactionDetails: '交易明细',
      pointsWithdrawal: '积分提现'
    },
    communityIntegralDetail: {
      id: '编号',
      integralAccount: '金币账户',
      type: '类型',
      transferIn: '转入',
      transferOut: '转出',
      transactionAmount: '交易金额',
      currentAmount: '当前金额',
      transactionNo: '交易单号',
      remark: '备注',
      time: '时间'
    },
    applyWithholdIntegral: {
      id: '编号',
      integralId: '积分ID',
      integralName: '积分名称',
      withdrawAmount: '提现金额',
      applicant: '申请人',
      applicantPhone: '申请人电话',
      bankAccount: '银行账户',
      accountName: '账号名称',
      bank: '开户行',
      applicationNote: '申请说明',
      status: '状态',
      reviewNote: '审核说明'
    },
    deleteApplyWithholdIntegral: {
      confirmTitle: '请确认您的操作！',
      confirmText: '确定删除申请',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    },
    withholdIntegral: {
      applyWithdraw: '申请提现',
      totalPoints: '总积分数',
      withdrawPoints: '提现积分',
      withdrawPointsPlaceholder: '必填，请填写提现积分',
      withdrawPointsRequired: '提现积分不能为空',
      applicant: '申请人',
      applicantPlaceholder: '必填，请填写申请人',
      applicantRequired: '申请人不能为空',
      applicantPhone: '申请人电话',
      applicantPhonePlaceholder: '必填，请填写申请人电话',
      applicantPhoneRequired: '申请人电话不能为空',
      bankAccount: '银行账户',
      bankAccountPlaceholder: '必填，请填写银行账户',
      bankAccountRequired: '银行账户不能为空',
      accountName: '账号名称',
      accountNamePlaceholder: '必填，请填写账号名称',
      accountNameRequired: '账号名称不能为空',
      bank: '开户行',
      bankPlaceholder: '必填，请填写开户行',
      bankRequired: '开户行不能为空',
      applicationNote: '申请说明',
      applicationNotePlaceholder: '必填，请填写申请说明',
applySuccess: '申請成功',
      applyFailed: '申請失敗'
    }
  },
  'zh-TW': {
    communityIntegral: {
      title: '小區積分',
      accountId: '帳戶ID：',
      accountName: '帳戶名稱：',
      points: '積分數：',
      withdraw: '提現',
      transactionDetails: '交易明細',
      pointsWithdrawal: '積分提現'
    },
    communityIntegralDetail: {
      id: '編號',
      integralAccount: '金幣帳戶',
      type: '類型',
      transferIn: '轉入',
      transferOut: '轉出',
      transactionAmount: '交易金額',
      currentAmount: '當前金額',
      transactionNo: '交易單號',
      remark: '備註',
      time: '時間'
    },
    applyWithholdIntegral: {
      id: '編號',
      integralId: '積分ID',
      integralName: '積分名稱',
      withdrawAmount: '提現金額',
      applicant: '申請人',
      applicantPhone: '申請人電話',
      bankAccount: '銀行帳戶',
      accountName: '帳號名稱',
      bank: '開戶行',
      applicationNote: '申請說明',
      status: '狀態',
      reviewNote: '審核說明'
    },
    deleteApplyWithholdIntegral: {
      confirmTitle: '請確認您的操作！',
      confirmText: '確定刪除申請',
      cancel: '點錯了',
      confirmDelete: '確認刪除',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗'
    },
    withholdIntegral: {
      applyWithdraw: '申請提現',
      totalPoints: '總積分數',
      withdrawPoints: '提現積分',
      withdrawPointsPlaceholder: '必填，請填寫提現積分',
      withdrawPointsRequired: '提現積分不能為空',
      applicant: '申請人',
      applicantPlaceholder: '必填，請填寫申請人',
      applicantRequired: '申請人不能為空',
      applicantPhone: '申請人電話',
      applicantPhonePlaceholder: '必填，請填寫申請人電話',
      applicantPhoneRequired: '申請人電話不能為空',
      bankAccount: '銀行帳戶',
      bankAccountPlaceholder: '必填，請填寫銀行帳戶',
      bankAccountRequired: '銀行帳戶不能為空',
      accountName: '帳號名稱',
      accountNamePlaceholder: '必填，請填寫帳號名稱',
      accountNameRequired: '帳號名稱不能為空',
      bank: '開戶行',
      bankPlaceholder: '必填，請填寫開戶行',
      bankRequired: '開戶行不能為空',
      applicationNote: '申請說明',
      applicationNotePlaceholder: '必填，請填寫申請說明',
      applySuccess: '申請成功',
      applyFailed: '申請失敗'
    }
  }
}